import { config } from '@/config';

const CRISP_APP_NAME = 'Synctrack OrderTrack';

/** token_id định danh Crisp theo shop. Điểm sinh token_id DUY NHẤT. */
export const getCrispTokenId = (shop: string): string => btoa(shop + CRISP_APP_NAME);

/**
 * True khi app mở từ CMS (impersonate) → phải ẩn Crisp.
 * Đọc từ nguồn ỔN ĐỊNH, KHÔNG phụ thuộc query string URL hiện tại:
 * - config.scope: đọc 1 lần từ URL entry (bất biến qua điều hướng SPA).
 * - tokenScope: scope đã persist trong token (sống sót hard reload).
 */
export const getIsHiddenChatFromAdmin = (tokenScope?: string): boolean => !!config.scope || !!tokenScope;

/**
 * True khi cần Crisp.session.reset() trước khi bind: đã bind token_id trước đó
 * (marker) và nó khác token_id shop hiện tại → tránh ghi đè session shop cũ.
 */
export const shouldResetCrispSession = (lastTokenId: string | null, currentTokenId: string): boolean =>
  !!lastTokenId && lastTokenId !== currentTokenId;

export const handleSendMoreShipmentMessage = () => {
  try {
    $crisp.push(['do', 'chat:show']);
    $crisp.push(['do', 'chat:open']);
    $crisp.push(['do', 'message:send', ['text', 'I want to discuss for more shipments volumn for Order Tracking app']]);
    $crisp.push(['set', 'session:data']);
  } catch (error) {
    console.log('error', error);
  }
};

export const handleOpenChat = () => {
  try {
    $crisp.push(['do', 'chat:show']);
    $crisp.push(['do', 'chat:open']);
  } catch (error) {
    console.log('error', error);
  }
};

export const handleSendMessage = (message: string) => {
  try {
    $crisp.push(['do', 'chat:show']);
    $crisp.push(['do', 'chat:open']);
    $crisp.push(['do', 'message:send', ['text', message]]);
  } catch (error) {
    console.log('error', error);
  }
};
